import { render, staticRenderFns } from "./property-warehouse.vue?vue&type=template&id=335b5cc9&"
import script from "./property-warehouse.vue?vue&type=script&lang=js&"
export * from "./property-warehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports